'use strict';

// extended ng-bind-html to include all custom elements and behavior
// TODO: we can use custom directive to compile html. Think about pros/cons
app.directive('ngBindHtml', function ($rootScope, $timeout, $compile, $location, $popup, rmModals) {
  return {
    priority: -100,
    link: function (scope, element, attrs) {

      var major = scope.$eval(attrs.rmModalMajorInlines);

      // watch to make it "live" in admin preview
      scope.$watch(attrs.ngBindHtml, function () {
        $timeout(function () {

          // first add links to "minor inline components"
          if (major) {
            var html = element.html();
            _(major.minors).filter({ type: 'inline' }).forEach(function (inline) {
              var phrase = _.escapeRegExp(inline.data.phrase);
              var anchor = '<a class="minor-inline" modal="' + (inline.href || '') + '">$&</a>';
              if (!phrase) { return; }
              html = html.replace(/(<.*?>)?([^<]+)(<.*?>)?/gi, function (match, p1, p2, p3) {
                return (p1 || '') + p2.replace(RegExp(phrase, 'gi'), anchor) + (p3 || '');
              });
            }).value();
            element.html(html);
          }

          // then make all user links to open in new window
          element.find('a').attr('target', '_blank');

          // then compile all macros, but not in admin
          if (!$rootScope.alc) {
            var macros = angular.element(element[0].querySelectorAll('.rm-macro'));
            _.forEach(macros, function ($macro) {
              $compile($macro)(scope);
            });
          }

        });
      });

      element.on('click', function (event) {
        var target = angular.element(event.target);

        // open pdf modal, but not in admin
        if (!scope.$root.alc) {
          if (target.hasClass('rm-file')) {
            var src = JSON.parse(target.attr('src'));
            $popup('pdf', { type: 'inline', src: src });
          }
        }

        // open inline component modal popover
        if (target.hasClass('minor-inline')) {
          var name = target.attr('modal');
          if (!name) { return; }
          rmModals.addModalLink(name, target);
          $timeout(function () {
            $location.hash(name);
          });
        }

      });

    }
  };
});
